import { fromJS, get, List, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

import { makeSemanticInstruction } from '#utils/instructions/shared/makeSemanticInstruction';

import type { WorkflowSemanticInstruction } from '../../workflowUtils';

export class ScheduledChange extends Record({
  _id: '',
  _version: 0,
  executionDate: 0,
  instructions: List<WorkflowSemanticInstruction>(),
  _maintainerId: '',
  _maintainerServiceTokenId: undefined as string | undefined,
  _creationDate: 0,
  conflicts: List(),
  _links: {
    self: {
      href: '',
      type: '',
    },
  },
}) {
  getCreationDate() {
    return this._creationDate;
  }
  getExecutionDate() {
    return this.executionDate;
  }

  getInstructionKinds() {
    return Object.values(this.instructions.toJS()).map((ins) => ins.kind);
  }

  getInstructions() {
    return this.instructions;
  }

  getID() {
    return this._id;
  }

  getMaintainerId() {
    return this._maintainerId;
  }

  getMaintainerServiceTokenId() {
    return this._maintainerServiceTokenId;
  }
}

export function createScheduledChange(props: CreateFunctionInput<ScheduledChange> = {}) {
  const scheduledFlagChanges = props instanceof ScheduledChange ? props : new ScheduledChange(fromJS(props));
  return scheduledFlagChanges.update('instructions', (vs) =>
    vs.size > 0 ? vs.map((v) => makeSemanticInstruction(get(v, 'kind', ''), v)) : List(),
  );
}
